/**
 * @description 发货通知单页面混入
 * @author: 菩萨蛮
 * @date 2020/9/29 9:20 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */
import SaleOrderDialog from 'Components/order/NoticeOrder/SaleOrderDialog';
import BatchListDialog from 'Components/order/NoticeOrder/BatchListDialog';
import AddressSelectDrawer from 'Components/order/NoticeOrder/AddressSelectDrawer';
import AddressAddDialog from 'Components/order/NoticeOrder/AddressAddDialog';
import * as math from 'mathjs';
import calculate from '../../plugins/calculate';
import qs from 'qs';

const noticeOrderMixin = {
  components: { SaleOrderDialog, BatchListDialog, AddressSelectDrawer, AddressAddDialog },
  props: {
    url: {
      type: String,
      default: '/sales/notice_order'
    }
  },
  computed: {
    unitPriceMinByCurrencyUnit() {
      const obj = this.unitPriceMinList.find(item => item.name === '人民币');
      if (obj) {
        return obj.rate || 0;
      }
      return 0;
    },
    orderBtnDisabled() {
      return !!this.utils.isEmpty(this.dataObj.custName && this.dataObj.userName);
    },
    goodsType() {
      return this.dataObj.goodsType;
    },
    totalWeight() {
      let total = 0;
      if (this.qxList.value.orderDetailsList.length > 0) {
        this.qxList.value.orderDetailsList.forEach(item => {
          total = math.number(math.add(math.bignumber(total), math.bignumber(item.goodsWeight || 0)));
        });
      }
      this.dataObj.totalWeight = total;
      return total.toFixed(1);
    },
    totalQuantity() {
      let total = 0;
      if (this.qxList.value.orderDetailsList.length > 0) {
        this.qxList.value.orderDetailsList.forEach(item => {
          if (item.noticeMainCount) {
            total = math.number(math.add(math.bignumber(total), math.bignumber(item.noticeMainCount)))
          }
        });
      }
      this.dataObj.totalQuantity = total;
      return total;
    },
  },
  data() {
    return {
      currentCustomer: {
        collaboratorInfos: []
      },
      addressAddVisible: false,
      addressList: [],
      billAddressList: [],
      deliveryAddressList: [],
      addressDrawervisible: false,
      deliveryAddress: '',
      billAddress: '',
      tableIndex: -1,
      deliveryAddressTableIndex: -1,
      billAddressTableIndex: -1,
      addressType: '',
      submitDisable: false,
      transferIsShow: false,
      billIsShow: false,
      contactList: [],
      userNameOptions:[],
      goodStatusOptions:[{
        value: 1,
        label: '未检验'
      },{
        value: 2,
        label: '检验中'
      },{
        value: 3,
        label: '已检验'
      }],
      defaultWarehouse: '',
      defaultWarehouseId: '',
      values: {
        contact: ''
      },
      dialog: {
        orderVisible: false
      },
      logistics: {
        shippingMethod: '',
        logistics: '',
        logisticsRemark: '',
        file: [],
        saleFile: []
      },
      mainUnitList: [],
      deputyUnitList: [],
      file: [],
      saleFile: [],
      addressValue: {
        country: '国内',
        selectAddress: ['', '', ''],
        detailAddress: ''
      },
      settlePlans: [{
        ways: '',
        way: '',
        month: '0',
        day: 0,
        percent: '0'
      }],
      custSettlePlans: [],
      ourAccountList: [],
      customerData: '',
      customerOptions: [],
      addressLists: [],
      deliveryTimePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      noticeMainCountMin: 0,
      unitPriceMinList: [],
      goodsToNoticeObj: {},
      stockToNoticeObj: {}
    };
  },
  created() {
    this.getUnitList('成品');
    this.getUnitPriceMinList();
  },
  async mounted() {
    // await this.getWarehouse();
    await this.getAddress();
    await this.getUserName();
  },
  watch: {
    'dataObj.userName': {
      handler() {
        if (this.dataObj.userName === '大货') {
          this.noticeMainCountMin = 30;
        } else {
          this.noticeMainCountMin = 1;
        }
      }
    }
  },
  methods: {
    async getUnitPriceMinList() {
      const { data } = await this.qGet('/global/currencyExchangeRate/list');
      if (data) {
        this.unitPriceMinList = [...data];
      }
    },
    ifCompare(object1, object2) {
      if (!object1) return false;
      if (!object2) return false;
      var o1keys = Object.keys(object1);
      var o2keys = Object.keys(object2);
      if (o2keys.length !== o1keys.length) return false;
      for (let i = 0; i <= o1keys.length - 1; i++) {
        let key = o1keys[i];
        if (!o2keys.includes(key)) return false;
        if (object2[key] !== object1[key]) return false;
      }
      return true;
    },
    billIsShowChange(e) {
      if (!e) {
        this.billAddress = this.deliveryAddress;
        this.dataObj.billAddress = this.dataObj.address;
        this.dataObj.billContactName = this.dataObj.contactName;
        this.dataObj.billContactPhone = this.dataObj.contactPhone;
      } else {
        this.billAddress = '';
        this.dataObj.billAddress = {
          other: '',
          province: '',
          city: '',
          county: '',
          street: '',
          country: ''
        };
        this.dataObj.billContactName = '';
        this.dataObj.billContactPhone = '';
      }
    },
    async getCustomer(id) {
      const { data } = await this.qGet(`/customer/wechat/customer/app?customerBind=true&status=1&id=${id}&pageSize=99`);
      this.currentCustomer = data.datas[0];
      this.customerData = `${this.dataObj.baseInfoV.custName}/${this.currentCustomer.name}/${this.currentCustomer.phone}`;
      if (this.currentCustomer.contactInfos === null || this.currentCustomer.contactInfos.length === 0) {
        this.currentCustomer.contactInfos = [];
      }
      this.billAddressList = this.currentCustomer.contactInfos.filter(item => item.bill).map((item,index) => {
        return {
          ...item,
          tableId: index
        }
      });
      this.deliveryAddressList = this.currentCustomer.contactInfos.filter(item => !item.bill).map((item,index) => {
        return {
          ...item,
          tableId: index
        }
      });
    },
    async getAddress() {
      const { data } = await this.qGet('/global/address/queryAll');
      if (data) {
          this.addressLists = this.addNewProp(data);
      }
    },
    addNewProp(arr) {
        return arr.map(item => {
            if (item.children && item.children.length > 0) {
                return {
                    ...item,
                    value: item.name,
                    label: item.name,
                    code: item.code,
                    children: this.addNewProp(item.children).map(child => ({
                        ...child,
                    })),
                };
            } else {
                return {
                    ...item,
                    value: item.name,
                    label: item.name,
                    code: item.code,
                    children: undefined
                };
            }
        });
    },
    async customerRemoteMethod(query) {
      this.customerOptions = [];
      const { data } = await this.qGet(`/customer/wechat/customer/app?customerBind=true&status=1&custInfoAggregation=${query}&pageSize=99`);
      let index = 0;
      data.datas.forEach(item => {
        item.custInfos.forEach(i => {
          if (i.custName.indexOf(query) !== -1 || item.name.indexOf(query) !== -1 || item.phone.indexOf(query) !== -1) {
            this.customerOptions.push({
              ...item,
              custInfo: i,
              tableId: index,
              value: `${i.custName}/${item.name}/${item.phone}`,
              label: `${i.custName}/${item.name}/${item.phone}`
            })
            index = index + 1;
          }
        })
      })
    },
    async setOrderDetailsList(searchObj) {
      const { data } = await this.qGet({
        notEncode: true,
        url: `/sales/sale_order/notice?${qs.stringify({
          status: [2, 3, 4, 5],
          goodsType: this.goodsType,
          custName: this.dataObj.custName,
          orderOperatorName: this.dataObj.userName,
          type: '大货',
          ...searchObj
        })}&pageSize=30`
      });
      if (!data.datas || data.datas.length === 0) {
        this.$message.error('暂无下单权限，请联系业务人员！')
        return;
      }
      if (data && data.datas) {
        const goodsList = data.datas.map(e => ({
          ...e,
          ...e.goodsInfo,
          orderId: e.id,
          saleOrderQuantity: e.goodsInfo.mainQuantity,
          saleUnit: e.goodsInfo.mainQuantityUnit,
          remark: '',
          settlePlans: e.settlePlans
        }));
        let orderType = '';
        if (searchObj.queryType === '2') {
          orderType = '2';
        }
        if (searchObj.queryType === '3') {
          orderType = '1';
        }
        const rowList = goodsList.map(item => ({
          ...item,
          orderCount: item.orderCountMeterOrKg,
          noticeMainUnit: item.mainQuantityUnit,
          noticeMainUnitId: this.mainUnitList.find(e => e.unit === item.mainQuantityUnit).id,
          goodsWeight: 0,
          batchList: [],
          orderType,
          noticeMainCount: orderType === '1' ? item.quantity : undefined,
          printLabel: {
            customer: this.dataObj.custName,
            customerRef: item.saleContractNo || '',
            style: item.modelNumber || '',
            color: item.custColorName || '',
            millRef: item.custGoodsNo || '',
            compo: item.blendName || '',
            cuttableWidth: item.width || '',
            weight: item.weight || '',
            rollRef: item.testVolumeCode || '',
            remark: ''
          }
        }))
        this.selectOrder(rowList);
      }
    },
    setCustomer(e) {
      this.currentCustomer = e;
      this.handleSelectCustomer(this.currentCustomer);
      this.billAddressClear();
      this.billIsShow = false;
      this.qxList.value.orderDetailsList = [];
      if (Object.keys(this.goodsToNoticeObj).length !== 0) {
        let searchObj = {
          goodsNo: this.goodsToNoticeObj.goodsCode,
          queryType: '2'
        }
        this.setOrderDetailsList(searchObj);
        this.goodsToNoticeObj = {};
        return;
      }
      if (Object.keys(this.stockToNoticeObj).length !== 0) {
        let searchObj = {
          saleOrderNoIn: this.stockToNoticeObj.orderStockList,
          queryType: '3'
        }
        this.setOrderDetailsList(searchObj);
        this.stockToNoticeObj = {};
        return;
      }
    },
    clearCustomer() {
      this.customerData = '';
      this.addressList = [];
      this.dataObj.custName = '';
      this.dataObj.custId = '';
      this.dataObj.contactName = '';
      this.dataObj.contactPhone = '';
      this.dataObj.custClueId = '';
      this.dataObj.custDeptName = '';
      this.dataObj.custDeptId = '';
      this.dataObj.custUserName = '';
      this.dataObj.custUserId = '';
      this.dataObj.alias = '';
      this.dataObj.orderOperatorName = '';
      this.dataObj.orderOperatorId = null;
      this.dataObj.orderOperatorPhone = '';
      this.custSettlePlans = [];
      this.qxList.value.orderDetailsList = [];
      this.addressClear();
      this.billAddressClear();
      this.billIsShow = false;
    },
    customerChange(e) {
      this.currentCustomer = this.customerOptions.find(item => item.value === e);
      this.handleSelectCustomer(this.currentCustomer);
    },
    handleSelectCustomer(e) {
      this.dataObj.custAccountInfo = {};
      this.dataObj.custName = e.custInfo.custName;
      this.dataObj.custId = e.custInfo.id;
      this.dataObj.custClueId = e.id;
      this.dataObj.custDeptName = e.custInfo.deptName;
      this.dataObj.custDeptId = e.custInfo.deptId;
      this.dataObj.custUserName = e.custInfo.userName;
      this.dataObj.custUserId = e.custInfo.userId;
      this.billAddressList = e.contactInfos.filter(item => item.bill).map((item,index) => {
        return {
          ...item,
          tableId: index
        }
      });
      this.deliveryAddressList = e.contactInfos.filter(item => !item.bill).map((item,index) => {
        return {
          ...item,
          tableId: index
        }
      });
      this.billAddressTableIndex = this.billAddressList.findIndex(item => item.main);
      this.deliveryAddressTableIndex = this.deliveryAddressList.findIndex(item => item.main);
      if (this.deliveryAddressTableIndex !== -1) {
        this.addressType = 'delivery';
        this.addressSelectSubmit(this.deliveryAddressList[this.deliveryAddressTableIndex]);
      } else {
        this.deliveryAddress = '';
        this.dataObj.address = null;
      }
      if (e.mainCollaborator) {
        let user = e.collaboratorInfos.find(item => item.id === e.mainCollaborator);
        this.dataObj.orderOperatorName = user.userName;
        this.dataObj.orderOperatorId = Number(user.userId);
        this.dataObj.orderOperatorPhone = user.userPhone;
        this.dataObj.alias = user.userAlias;
      } else {
        this.dataObj.alias = '';
        this.dataObj.orderOperatorName = '';
        this.dataObj.orderOperatorId = null;
        this.dataObj.orderOperatorPhone = '';
      }
      if (e.custInfo.settlePlans && e.custInfo.settlePlans.length >= 1) {
        e.custInfo.settlePlans.forEach(item => {
          if (item.way === '定金' || item.way === '现款') {
            item.ways = item.way;
          } else {
            item.ways = '欠款';
          }
          item.month = item.month.toString();
          item.percent = item.percent.toString();
        });
        this.custSettlePlans = JSON.parse(JSON.stringify(e.custInfo.settlePlans));
        this.settlePlans = JSON.parse(JSON.stringify(e.custInfo.settlePlans));
      }
    },
    addressClear() {
      this.deliveryAddress = '';
      this.dataObj.address = {
        other: '',
        province: '',
        city: '',
        county: '',
        street: '',
        country: ''
      };
      if (this.$refs.addressSelectDrawer !== undefined) {
        this.tableIndex = -1;
      }
    },
    billAddressClear() {
      this.billAddress = '';
      this.dataObj.billAddress = {
        other: '',
        province: '',
        city: '',
        county: '',
        street: '',
        country: ''
      };
      if (this.$refs.addressSelectDrawer !== undefined) {
        this.tableIndex = -1;
      }
    },
    async addressSelect(type) {
      this.$refs[`${type}Address`].blur();
      if (this.customerData === '') {
        this.$message.warning('请先选择客户')
      } else {
        this.addressDrawervisible = true;
        this.addressType = type;
        this.addressList = this[`${type}AddressList`];
        this.tableIndex = this[`${type}AddressTableIndex`];
      }
    },
    addressSelectClose() {
      this.addressDrawervisible = false;
    },
    addressSelectSubmit(e) {
      this[`${this.addressType}AddressTableIndex`] = e.tableId;
      this.tableIndex = e.tableId;
      if (e.province === '') {
        this[`${this.addressType}Address`] = ` ${e.contactName} ${e.phoneNumber} ${e.contactAddress}`;
      } else {
        this[`${this.addressType}Address`] = `${e.contactName} ${e.phoneNumber} ${e.province}/${e.city}/${e.county}/${e.street}/${e.contactAddress}`;
      }
      if (this.addressType === 'delivery') {
        this.dataObj.address = {
          other: e.contactAddress || '',
          province: e.province || '',
          city: e.city || '',
          county: e.county || '',
          street: e.street || '',
          country: e.country || ''
        };
        this.dataObj.contactName = e.contactName;
        this.dataObj.contactPhone = e.phoneNumber;
        if (!this.billIsShow) {
          this.dataObj.billAddress = this.dataObj.address;
          this.dataObj.billContactName = this.dataObj.contactName;
          this.dataObj.billContactPhone = this.dataObj.contactPhone;
        }
      }
      if (this.addressType === 'bill') {
        this.dataObj.billAddress = {
          other: e.contactAddress || '',
          province: e.province || '',
          city: e.city || '',
          county: e.county || '',
          street: e.street || '',
          country: e.country || ''
        };
        this.dataObj.billContactName = e.contactName;
        this.dataObj.billContactPhone = e.phoneNumber;
      }
      this.addressDrawervisible = false;
    },
    addAddressShow() {
      this.addressAddVisible = true;
    },
    addAddressClose() {
      this.addressAddVisible = false;
    },
    async submitAddress(e) {
      this.currentCustomer.contactInfos.push({
        ...e.form,
        bill: e.type === 'bill',
        main: false
      });
      const { code, data } = await this.qPut({
        url: '/customer/wechat/customer/app',
        data: this.currentCustomer
      });
      if (code === 200) {
        this.$message.success('地址添加成功');
        this.addressAddVisible = false;
        this.billAddressList = data.contactInfos.filter(item => item.bill).map((item,index) => {
          return {
            ...item,
            tableId: index
          }
        });
        this.deliveryAddressList = data.contactInfos.filter(item => !item.bill).map((item,index) => {
          return {
            ...item,
            tableId: index
          }
        });
        this.addressList = this[`${this.addressType}AddressList`];
        this.tableIndex = this[`${this.addressType}AddressList`].length - 1;
        this[`${this.addressType}AddressTableIndex`] = this.tableIndex;
        this.$refs.addressSelectDrawer.tableRadio = this[`${this.addressType}AddressList`].length - 1;
        this.$refs.addressAddDialog.form = {
          contactName: '',
          phoneNumber: '',
          country: '',
          area: '',
          contactAddress: '',
          province: '',
          city: '',
          county: '',
          street: '',
        },
        this.$refs.addressAddDialog.identifyAddress = '';
      }
    },
    blurNoticeMainCount(row, index) {
      if (row.noticeMainCount < this.noticeMainCountMin) {
        this.$message.error(`请注意：${this.dataObj.userName}最少下单数量为${this.noticeMainCountMin}m！`);
        this.$refs[`noticeMainCount${index}`].$refs.input.$refs.input.style.color='red';
        this.$refs[`noticeMainCount${index}`].$refs.input.$refs.input.style.borderColor='red'
      } else {
        this.$refs[`noticeMainCount${index}`].$refs.input.$refs.input.style.color='';
        this.$refs[`noticeMainCount${index}`].$refs.input.$refs.input.style.borderColor=''
      }
    },
    onFocus(event) {
      event.currentTarget.select();
    },
    setDefaultSettlePlan(item) {
      this.settlePlans = item;
    },
    setSaleOrderQuantity() {
      this.qxList.value.orderDetailsList.forEach(item => {
        if (item.saleOrderQuantity === undefined) {
          item.saleOrderQuantity = item.noticeMainCount;
        }
      })
    },
    async updateDraft() {
      if (!this.dataObj.custName) {
        this.$message.error('客户不可为空！')
        return;
      }
      await this.localInitData();
      const data = this.getSubmitData();
      await this.goUpdateDraft(true, data);
    },
    async goUpdateDraft(needAudit, data) {
      const { code } = await this.qPut({
        url: `${this.url}/draft`,
        data
      });

      if (code === 200) {
        this.$message.success('保存草稿成功！');
        this.close(true);
      }
    },
    async submitDraft() {
      await this.localInitData();
      this.setSaleOrderQuantity();
      const str = this.validate();
      if (!this.utils.isEmpty(str)) {
        this.$message.error(str);
        return;
      }
      const data = this.getSubmitData();
      await this.goSubmitDraft(true, data);
    },
    async goSubmitDraft(needAudit, data) {
      const { code } = await this.qPost({
        url: this.url,
        data
      });

      if (code === 200) {
        this.$message.success('新增成功！');
        this.close(true);
      }
    },
    async draft() {
      if (!this.dataObj.custName) {
        this.$message.error('客户不可为空！')
        return;
      }
      await this.localInitData();
      const data = this.getSubmitData();
      await this.goDraft(true, data);
    },
    async goDraft(needAudit, data) {
      const { code } = await this.qPost({
        url: `${this.url}/draft`,
        data: {
          ...data,
          baseInfoV: {
            ...data.baseInfoV,
            createSource: 'SCM'
          }
        }
      });

      if (code === 200) {
        this.$message.success('保存草稿成功！');
        this.close(true);
      }
    },
    changeTransferInfo(callback) {
      if (callback === false) {
          this.dataObj.transferInfo = '';
      }
    },
    weightFormatter(row, column) {
      let goodsWeight = 0;
      if (row.noticeMainUnit === '米') {
        goodsWeight = math.number(math.multiply(math.bignumber(row.weight || 0), math.bignumber(row.width || 0), math.bignumber(row.noticeMainCount || 0), math.bignumber(0.00001)))
        // goodsWeight = row.weight * row.width * row.noticeMainCount / 100 / 1000
      }
      if (row.noticeMainUnit === '码') {
        goodsWeight = math.number(math.multiply(math.bignumber(row.weight || 0), math.bignumber(row.width || 0), math.bignumber(row.noticeMainCount || 0), math.bignumber(0.9144), math.bignumber(0.00001)))
        // goodsWeight = row.weight * row.width * 0.9144 * row.noticeMainCount / 100 / 1000
      }
      if (row.noticeMainUnit === '千克') {
        goodsWeight = row.noticeMainCount
      }
      if (isNaN(goodsWeight)) {
        goodsWeight = 0
      }
      row.goodsWeight = goodsWeight;
      return !row.goodsNo ? '' : goodsWeight.toFixed(1);
    },
    async getUserName() {
      const { data } = await this.qGet('user/dept');
      data.forEach(item => {
        if (item.name === this.dataObj.userName) {
          this.userNameOptions.push({
            id: item.id,
            name: item.name
          })
        }
      });
      this.dataObj.userId = this.userNameOptions[0].id;
    },
    async getUnitList(e) {
      const { data } = await this.qGet(`base/config/unit?goodsType=${e}`);
      this.mainUnitList = [];
      this.deputyUnitList = [];
      data.datas.forEach(unit => {
        if (unit.unitType === '主单位') {
          this.mainUnitList.push(unit);
        } else {
          this.deputyUnitList.push(unit);
        }
      });
    },
    async getWarehouse() {
      this.warehouseOptions = [];
      const { data } = await this.qGet('/warehouse/warehouses/available?name=&pageSize=5&pageNum=0')
      if (data && data.length > 0) {
        if (this.dataObj.userName === '大货') {
          this.defaultWarehouse = '前进研发基地-检验';
        }
        if (this.dataObj.userName === '样品') {
          this.defaultWarehouse = '新天元样品仓';
        }
        this.defaultWarehouseId = data.find(item => item.name === this.defaultWarehouse).id;
      }
    },
    changeWarehouse(row) {
      row.warehouseId = this.warehouseOptions.find(item => item.label === row.warehouse).value;
    },
    setMainUnit(obj) {
      const { index, unit } = obj;
      this.qxList.value.orderDetailsList[index].noticeMainUnit = unit.unit;
      this.qxList.value.orderDetailsList[index].noticeMainUnitId = unit.id;
    },
    openOrderDialog() {
      this.dialog.orderVisible = true;
    },
    closeOrderDialog() {
      this.dialog.orderVisible = false;
    },
    selectOrder(data) {
      let result = data.map(item => {
        return {
          ...item,
          unitPrice: this.getUnitPrice(item),
        //   warehouse: this.defaultWarehouse,
        //   warehouseId: this.defaultWarehouseId
          warehouse: '',
          warehouseId: ''
        }
      });
      this.qxList.value.orderDetailsList.push(...result);
      this.closeOrderDialog();
    },
    getUnitPrice(item) {
      if (this.dataObj.userName === '样品' && this.dataObj.simpleType === '米样') {
        return this.unitPriceMinByCurrencyUnit;
      }
      if (this.dataObj.userName === '大货') {
        if (item.taxUnitPrice !== undefined) {
          return item.taxUnitPrice;
        }
        return this.unitPriceMinByCurrencyUnit;
      }
      return this.unitPriceMinByCurrencyUnit;
    },
    removeOrderDetailsList(i) {
      this.qxList.value.orderDetailsList.splice(i, 1);
    },
    getQuantityToMeter(orderQuantity, orderUnit, item) {
        if (orderUnit === '码') {
            return calculate.toFixedRound(calculate.multiply(orderQuantity, 0.9144), 2);
        }
        if (orderUnit === '千克') {
            if (item.width && item.weight) {
                return calculate.toFixedRound(calculate.divide(orderQuantity, item.width, item.weight, 0.00001), 2);
            }
            return 0;
        }
        return orderQuantity;
    },
    localInitData() {
    },
    getSubmitData() {
      let result = {
        ...this.dataObj,
        baseInfoV: {
          ...this.dataObj,
          settlePlans: this.settlePlans
        },
        logistics: {
          ...this.logistics,
          file: this.file,
          saleFile: this.saleFile
        },
        orderList: this.qxList.value.orderDetailsList.map(item => {
            const orderQuantity = item.noticeMainCount || 0;
            const orderUnit = item.noticeMainUnit;
            const noticeMainCount = this.getQuantityToMeter(orderQuantity, orderUnit, item);
            const noticeMainUnit = '米';
            return {
              ...item,
              noticeMainCount,
              noticeMainUnit,
              orderQuantity,
              orderUnit
            }
        })
      };
      if (result.id) {
        result.noticeId = result.id;
      }
      return result;
    },
    async submit(needAudit = true) {
      // 必填参数校验
      await this.localInitData();
      this.setSaleOrderQuantity();
      const str = this.validate();
      if (!this.utils.isEmpty(str)) {
        this.$message.error(str);
        return;
      }
      // 本地参数自定义
      const isLocalPassValidateFlag = this.isLocalPassValidate();
      if (!isLocalPassValidateFlag) {
        return;
      }
      this.submitDisable = true;
      // 获取参数
      let data = this.getSubmitData();
      // 传递的参数设置自定义
      data = await this.submitValueSetting(data);
      await this.goSubmit(needAudit, data);
    },
    validate(listCheck = true, type = 'new') {
      let str = '';
      // 基本信息校验
      const { baseItemObj, dataObj } = this;
      const { isEmpty } = this.utils;
      const strList = Object.keys(dataObj).map(e => {
        const item = baseItemObj[e];
        // is required
        if (item !== undefined && item.required[type]) {
          if (isEmpty(dataObj[e])) {
            return item.title;
          }
        }
        return null;
      }).filter(e => e !== null);

      if (strList.length > 0) {
        str += `基本信息：${strList.join('、')}不可为空！`;
      }

      if (this.qxList.value.orderDetailsList.some(e => this.getQuantityToMeter(e.noticeMainCount, e.noticeMainUnit, e) < this.noticeMainCountMin)) {
        str += `本次发货数量必须大于${this.noticeMainCountMin}米！`;
      }

      if (!this.settlePlans || this.settlePlans.length < 1) {
        str += '账期不可为空！';
      } else {
        let sum = 0;
        this.settlePlans.forEach(item => {
          sum += Number(item.percent);
        });
        if (sum !== 100) {
          str += '账期百分比之和应为100！'
        }
      }

      if (listCheck) {
        str += this.childValidate(type);
      }

      this.qxList.value.orderDetailsList.forEach((item, index) => {
        const noticeMainCount = this.getQuantityToMeter(item.noticeMainCount || 0, item.noticeMainUniterUnit, item);
        if (!item.saleOrderNo && item.quantity !== 0 && noticeMainCount && noticeMainCount > item.quantity && item.orderType === '2') {
          str += `第${index+1}行：库存数量为${item.quantity}米，主数量超出库存数量！`;
        }
        if (item.transferOrderNums && item.noticeMainCount > item.transferOrderNums) {
          str += `第${index+1}行：主数量超出转入订单数量！`
        }
      });
      return str;
    },
    childValidate(type) {
      // 如果需要校验list  以后可能要扩展出来
      // 获取list title
      let str = '';
      const { baseItemObj, value } = this.qxList;
      const { notEmptyArr, isEmpty } = this.utils;
      const listParam = Object.keys(baseItemObj).map(e => e.slice(0, e.length - 4));
      const listTitle = listParam.map(l => this.baseItemObj[l].title);
      // 长度校验
      const emptyArr = Object.keys(value).map((e, i) => {
        const list = value[e];
        if (!notEmptyArr(list)) {
          return i;
        }
        return null;
      }).filter(e => e !== null);
      // 空列表校验 直接返回
      if (emptyArr.length > 0) {
        const strList = Object.values(emptyArr).map(i => listTitle[i]);
        str += `${strList.join('、')}不可为空！`;
        return str;
      }
      // 构造必填字段列表
      const requiredItemList = Object.keys(baseItemObj).map(key => {
        // 获取字段
        const itemObj = baseItemObj[key];
        // 获取校验对象
        return Object.keys(itemObj).map(k => {
          const item = itemObj[k];
          if (item.required[type]) {
            return { param: k, title: item.title };
          }
          return null;
        }).filter(e => e !== null);
      });
      str += Object.keys(value).map((e, i) => {
        // 遍历每个list
        const list = value[e];
        // 构造字符串obj和校验param
        const requiredItem = requiredItemList[i];
        const strObj = Object.create(null);
        const paramList = requiredItem.map(r => {
          strObj[r.param] = r.title;
          return r.param;
        });
        // 校验列表 核心部分

        const lessParam = new Set(list.map(l => paramList.filter(p => isEmpty(l[p]))).flat());
        // 转为中文 这个写法好蠢，但是好理解吧。
        const lessParamZH = [...lessParam].map(l => strObj[l]);
        return lessParamZH.length > 0 ? `${listTitle[i]}：${lessParamZH.join('、')}不可为空！` : '';
      });
      return str;
    }
  }
};

export default noticeOrderMixin;
